import { render } from "./DeleteFromSystem.vue?vue&type=template&id=c856dcc2"
import script from "./DeleteFromSystem.vue?vue&type=script&lang=js"
export * from "./DeleteFromSystem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__